$gd_bot $mol_book2
	Model? $mol_github_model
		params * temperature 0
		rules <= context <= rules \Ты - Гипер Бот, универсальный интеллектуальный ассистент. Пользователь присылает тебе запрос в виде JSON строки. Твоя задача сформировать максимально точный и лаконичный ответ на запрос без лишней информации, о которой пользователь не просил. Ответ должен быть представлен в виде JSON объекта, где в поле "response" должен находиться собственно ответ в виде строки. В поле "confidence" отрази степень своей увернности в истинности ответа в диапазоне от 0 до 1. В поле "digest" должен находиться краткий пересказ всего вашего диалога от начала до конца. Говоря о пользователе в пересказе (и только в нём) используй эмодзи 🙂 вместо слова "пользователь", а вместо "Гипер Бота" - используй эмозди 🤖. В поле "title" должно быть придумано лаконичное название, ёмко характеризующее всё обсуждение целиком. Отвечай всегда на языке с кодом {lang}, если пользователь не попросил иное. Далее идёт пересказ прошлых ваших сообщений, не потеряй его в своём пересказе:
	plugins /
		<= Theme $mol_theme_auto
	pages /
		<= Space $gd_web_frame
		<= Dialog $mol_page
			title_content /
				\🤖 
				<= title <= dialog_title? @ \Giper Bot
			body_content /
				<= Status $mol_status
					status <= communication null
				<= Messages $mol_list
					rows <= messages /
						<= Message*0 $mol_view sub /
							<= Message_text* $mol_text text <= message_text* \
			foot /
				<= Avatar $mol_view sub / \🙂
				<= Prompt_text $mol_textarea
					hint @ \Ask something
					value? <=> prompt_text? \
					submit? <=> prompt_submit? null
				<= Prompt_submit $mol_button_minor
					hint @ \Send
					click? <=> prompt_submit? 
					sub /
						<= Prompt_submit_icon $mol_icon_send
	placeholders /
		<= Context $mol_page
			title @ \Summary
			tools /
				<= Reset $mol_button_minor
					hint @ \Reset
					click? <=> reset? null
					sub /
						<= Reset_icon $mol_icon_trash_can_outline
				<= Sources $mol_link_source
					uri \https://github.com/giper-dev/bot/
				<= Donate $mol_link_donate
					uri \https://boosty.to/hyoo
				<= Support $mol_link_support
					uri \https://t.me/giper_web/276
				<= Lights $mol_lights_toggle
			body /
				- <= Digest_block $mol_labeler
					title @ \Digest
					Content
				<= Digest $mol_text
					text <= digest? \
				- <= Rules_block $mol_labeler
					title @ \Rules
					Content <= Rules $mol_text
						text <=
